/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForRedhatSatellite extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForRedhatSatellite");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForRedhatSatellite.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForRedhatSatellite>): ServiceAccountCredentialsForRedhatSatellite {
        let obj = Object.assign(new ServiceAccountCredentialsForRedhatSatellite(), model);
        ServiceAccountCredentialsForRedhatSatellite.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForRedhatSatellite>): ServiceAccountCredentialsForRedhatSatellite {
        if (!model) return null;
        return ServiceAccountCredentialsForRedhatSatellite.newInstance(<ServiceAccountCredentialsForRedhatSatellite> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForRedhatSatellite) {
        if (!obj) return;

        models.ServiceAccountCredentialsForRedhatSatellite.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForRedhatSatellite): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForRedhatSatellite.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SSL enabled or not
     */
    ssl_verify: boolean;

}
